// extracted by mini-css-extract-plugin
module.exports = {"pT":"#3182bd","pE":"#a020f0","sweetRegion":"#8ec0a4"};